import * as React from 'react'

/**
 * Allows you to use a ref as an effect dependency and have it react to
 * changes. Dan Abramov probably feels a disturbance in the force right now.
 */
export function useRefDep(ref: React.RefObject<Element | null>): unknown {
  const [lastRefValue, setLastRefValue] = React.useState<Element | null>(null)
  React.useEffect(() => setLastRefValue(ref.current))
  return lastRefValue
}
